import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrderDetailDialogComponent } from '../../modules/order/components/order-detail-dialog/order-detail.dialog.component';
import { OrderService } from '../../modules/order/order.service';
import { PrintService } from '../../modules/print/print.service';
import { OrdersOfLogonUser } from '../../services/Ebootis.Queries/OrdersOfLogonUser';
import { ConfigurationService, HelpDocument } from '../configuration-select/configuration.service';

export interface DialogOrderDetailData {
	order: string;
}

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {

	private m_selectedOrder: string = '';
	private m_subscriptionsSubject = new Subject();
	public m_displayError: HttpErrorResponse;
	public m_messageHandlerClass: string = 'info';
	public m_orderData: OrdersOfLogonUser.Result[];
	public m_helpDoc: HelpDocument = null;
	private m_currentDate = new Date();
	private m_beforeDate;
	constructor(
		private m_orderService: OrderService,
		public m_dialog: MatDialog,
		private cfgService: ConfigurationService,
		private m_printService: PrintService
	) { }

	/**
	 * Die letzten 5 Bestellungen der letzten 90 Tage swerden geladen, sowie die Adresse des Angemeldeten Benutzers.
	 */
	public ngOnInit(): void {
		this.m_beforeDate = new Date();
		this.m_beforeDate.setDate(this.m_currentDate.getDate() - 90);
		if (this.cfgService.SelectedConfigOid) {
			this.cfgService.getHelpDocument().pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({ next: (helpDoc) => this.m_helpDoc = helpDoc });
			this.m_orderService.searchOrders({
				zbsConfig: this.cfgService.SelectedConfigOid,
				txDateFrom: this.m_beforeDate,
				txDateUntil: this.m_currentDate,
				limit: 5,
			}).pipe(
				takeUntil(this.m_subscriptionsSubject),
			).subscribe({
				next: (data) => {
					// this.m_orderData = data.sort((a, b) => { return a.txDate < b.txDate ? 1 : -1 }).splice(0, 5);
					this.m_orderData = data;
				},
				error: (error) => {
					this.m_displayError = error;
					this.m_messageHandlerClass = 'danger';
				},
			});
		} else {
			console.error("Config nicht vorhanden");
		}
	}
	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	/**
	 * Öffnet einen modalen Dialog mit den Details der ausgewählten Order.
	 * @param p_order OID der ausgewählten Order
	 */
	public orderSelected(p_order: string): void {
		this.m_selectedOrder = p_order;
		const dialogRef = this.m_dialog.open(OrderDetailDialogComponent, {
			// minWidth: '100%',
			// maxWidth: '100%',
			// minWidth: '70%',
			minWidth: '100%',
			data: { order: this.m_selectedOrder },
		});
	}

	/**
	 * Die Nachrichten des MessageHandlers werden zurückgesetzt.
	 */
	public clearDisplayMessages(): void {
		this.m_displayError = null;
	}

}
